var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricalPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 10.9999C12.6667 10.4476 12.219 9.99992 11.6667 9.99992H5.33333C3.49238 9.99992 2 8.50753 2 6.66659C2 4.82564 3.49238 3.33325 5.33333 3.33325L7.33333 3.33325V4.66659L5.33333 4.66659C4.22876 4.66659 3.33333 5.56202 3.33333 6.66659C3.33333 7.77115 4.22876 8.66658 5.33333 8.66658H11.6667C12.9553 8.66659 14 9.71125 14 10.9999C14 12.2886 12.9553 13.3333 11.6667 13.3333H2.66667C2.29848 13.3333 2 13.0348 2 12.6666C2 12.2984 2.29848 11.9999 2.66667 11.9999H11.6667C12.219 11.9999 12.6667 11.5522 12.6667 10.9999Z",
    fill: "#840300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2H10.6667V3.33333H13.3334C13.7015 3.33333 14 3.03486 14 2.66667C14 2.29848 13.7015 2 13.3334 2Z",
    fill: "#840300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 4.66667H10.6667V6H13.3334C13.7015 6 14 5.70152 14 5.33333C14 4.96514 13.7015 4.66667 13.3334 4.66667Z",
    fill: "#840300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 2.66659H8.66667C7.93029 2.66659 7.33333 3.26354 7.33333 3.99992C7.33333 4.7363 7.93029 5.33325 8.66667 5.33325H10.6667V2.66659ZM8.66667 1.33325C7.19391 1.33325 6 2.52716 6 3.99992C6 5.47268 7.19391 6.66658 8.66667 6.66658H11.3333C11.7015 6.66658 12 6.36811 12 5.99992V1.99992C12 1.63173 11.7015 1.33325 11.3333 1.33325H8.66667Z",
    fill: "#840300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalPlug);
export default __webpack_public_path__ + "static/media/electrical_plug.5e26b40fc599960e2b4dd7a9ce30aecc.svg";
export { ForwardRef as ReactComponent };